/**
 * sourceManagementModule
 * author: Qian.qianchen 2019-02-26
 * description: 稿件来源管理
 */
"use strict";
angular.module("sourceManagementModule", ["sourceEditModule"])
    .controller("sourceManagementCtrl", ["$scope", "trsHttpService", "$modalInstance", "$q", "$modal", "modalDialog", function($scope, trsHttpService, $modalInstance, $q, $modal, modalDialog) {

        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                keywords: '',
                page: {
                    "CURRPAGE": 1,
                    "PAGESIZE": 10,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1
                }
            };
            $scope.data = {
                sourceArr: []
            };
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData description] 数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            var params = {
                "serviceid": "mlf_personalsource",
                "methodname": "queryPersionalSources",
                "SrcName": $scope.status.keywords,
                "PageSize": $scope.status.page.PAGESIZE,
                "CurrPage": $scope.status.page.CURRPAGE
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.status.page = data.PAGER;
                $scope.data.sourceArr = [];
                data.DATA.forEach(function(item, index) {
                    if (angular.isDefined(item.ISPERSIONAL) && item.ISPERSIONAL == 1) {
                        $scope.data.sourceArr.push(item);
                    }
                })
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [sourceEditModal description] 来源编辑弹窗
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        function sourceEditModal(item) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./editingCenter/service/sourceManagement/sourceEdit/sourceEdit_tpl.html",
                windowClass: "source-edit-window",
                backdrop: false,
                controller: "sourceEditCtrl",
                resolve: {
                    item: function() {
                        return item;
                    }
                }
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        }
        /**
         * [deleteSourceRequest description] 删除来源请求
         * @param  {[object]} item [description] 来源
         * @return {[type]}      [description]
         */
        function deleteSourceRequest(item) {
            var deffer = $q.defer();
            modalDialog.alertType('', '是否确认删除', 'ask', true, function() {
                var params = {
                    "serviceid": "mlf_personalsource",
                    "methodname": "deletePersionalSources",
                    "sourceIds": item.SOURCEID,
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    deffer.resolve();
                });
            });
            return deffer.promise;
        }

        /**
         * [cancel description] 弹窗关闭/取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        }
        /**
         * [addSource description] 添加来源
         */
        $scope.addSource = function() {
            sourceEditModal().then(function() {
                $scope.status.page.CURRPAGE = 1;
                $scope.status.keywords = '';
                requestData();
            });
        }
        /**
         * [editSource description] 来源编辑
         * @param  {[object]} item [description] 来源
         * @return {[type]}      [description]
         */
        $scope.editSource = function(item) {
            sourceEditModal(item).then(function() {
                $scope.status.page.CURRPAGE = 1;
                $scope.status.keywords = '';
                requestData();
            });
        }
        /**
         * [deleteSource description] 来源删除
         * @param  {[object]} item [description] 来源
         * @return {[type]}      [description]
         */
        $scope.deleteSource = function(item) {
            deleteSourceRequest(item).then(function() {
                modalDialog.alertType('', '删除成功', 'success', false);
                $scope.status.page.CURRPAGE = 1;
                $scope.status.keywords = '';
                requestData();
            });
        }
        /**
         * [pageChanged description] 分页翻页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.keywords = '';
            requestData();
        }
        /**
         * [fullTextSearch description] 搜索
         * @param  {[object]} ev [description] event
         * @return {[type]}    [description]
         */
        $scope.fullTextSearch = function(ev) {
            if (angular.isDefined(ev) && ev.keyCode == 13) {
                $scope.status.page.CURRPAGE = 1;
                requestData();
            }
        }
        /**
         * [confirm description] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function(){
            $modalInstance.close();
        }
    }]);